import { ThesisChapters } from "./chapters/ThesisChapters";
import { ProductChapters } from "./chapters/ProductChapters";
import { GrowthChapters } from "./chapters/GrowthChapters";
import { EconomicsChapters } from "./chapters/EconomicsChapters";

export const InvestorChapter = ({ chapter, data, onNext }) => {
  if (chapter.id <= 5) return <ThesisChapters chapter={chapter} data={data} onNext={onNext} />;
  if (chapter.id <= 14) return <ProductChapters chapter={chapter} data={data} />;
  if (chapter.id <= 20) return <GrowthChapters chapter={chapter} data={data} />;
  return <EconomicsChapters chapter={chapter} data={data} />;
};